import React, { useState } from 'react'
import './styles/Signup.css';
import md5 from 'md5';

const Signup = ({setUser}) => {
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    
    const fetchUser = async (username, password) => {
        // Create Date Stamp
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        const res = await fetch('https://GradientBack.3-sigma.repl.co/login', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({username:username, password:md5(password), date:dateStamp})
        })
        if (res.status !== 200) {
            alert("Login Failed. Please Try Again.", res.status)
            return
        } else {
            const data = await res.json()
            setUser(data)
        }
    }

    const login = (e) => {
        e.preventDefault()
        if (!verifyFields()) {
            return
        }
        fetchUser(username, password)
    }

    const createAcct = async () => {
        if (!verifyFields()) {
            return
        }
        // Create date stamp
        let newDate = new Date()
        let date = newDate.getDate();
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        const dateStamp = `${month<10?`0${month}`:`${month}`}-${date<10?`0${date}`:`${date}`}-${year}`
        const res = await fetch('https://GradientBack.3-sigma.repl.co/create-user', {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            body: JSON.stringify({username:username, password:md5(password), date:dateStamp})
        })
        if (res.status === 418) {
            alert('Username taken. Please Try Again.')
            return false
        } 
        else if (res.status !== 200) {
            alert('Account Creation Failed.', res.status)
        }
        else {
            const data = await res.json()
            setUser(data)
        }
    }

    function verifyFields () {
        if (!username && !password) {
            return false
        }
        else if (!username) {
            alert('Please add a username.')
            return false
        }
        else if (!password) {
            alert('Please enter a password.')
            return false
        }
        return true
    }

    return (
        <form className='login-form' onSubmit={login}>
                <input 
                type = 'text'
                placeholder='Username'
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className = 'main-login-form-item'
                />

                <input
                 type='password'
                 placeholder='Password'
                 value={password}
                 onChange={(e) => setPassword(e.target.value)}
                 className = 'main-login-form-item'
                />
                <input 
                type='submit' 
                value = 'Log In'
                id = "login-btn" 
                className = 'btn main-login-form-item'/>

                <div id = "login-or-line" className = "main-login-form-item">
                <span className = 'line'/>
                <label id= 'login-or-label'>or</label>
                <span className = 'line'/>
                </div>

                <div 
                type = "div"
                id = "create-account-btn" 
                className = 'btn main-login-form-item'
                onClick = {createAcct}>Create Account</div>
        </form>
    )
}

export default Signup
